import { invoke } from '@shared/easyfy.decorators';
import { initHorizontalScrollFade } from '@clientShared/horizontalScrollFade';

@invoke
export default class PopularBrandsComponent {
  onInit() {
    // Scoped by class so the search panel's own fade containers are left to the search module
    initHorizontalScrollFade(document.querySelectorAll<HTMLElement>('.popular-brands-component[data-container="horizontal-fade"]'));
  }
}
